import decimal from '../../../math/decimal';
import SymbolParser from '../../symbol/SymbolParser';
import { BidAskMidFn } from '../types/BidAskMidFn';
import roundMid from './roundMid';

const calculateSingleLegQuote: BidAskMidFn = ({ legs, strategy, isSell }) => {
  if (!legs?.length || !strategy) {
    return undefined;
  }

  const leg = legs?.[0];

  const ask = decimal(leg.ask);
  const bid = decimal(leg.bid);

  if (ask === undefined || bid === undefined) {
    return undefined;
  }

  const parser = new SymbolParser(legs[0].symbol);
  const isSPX = parser.isSPX;
  const ROUNDING_VALUE = isSPX ? 0.05 : 0.01;

  const mid = ask.plus(bid).dividedBy(2);

  return {
    ask: ask.toNumber(),
    bid: bid.toNumber(),
    mid:
      roundMid({ mid, isSell, strategy })
        ?.toNearest(ROUNDING_VALUE)
        ?.toNumber() || 0.01,
    open: leg.open
      ? roundMid({ mid: decimal(leg.open), isSell, strategy })
          ?.toNearest(ROUNDING_VALUE)
          ?.toNumber() || 0.01
      : undefined,
    last: leg.last,
    close: leg.close,
    prevclose: leg.prevclose,
  };
};

export default calculateSingleLegQuote;
